import React from "react";
import CCarousel from "../../carousel/carousel.js";
import { newsFetch } from "../../util/auth.js";
import NewsModule from "../../news/newsModule.js";
import styles from "./home.module.css";

class Home extends React.Component {
  constructor(props) {
    super(props);
      this.state = {
          data: []
      };
  }
    componentDidMount() {
        var request = { From: null, To: null, Count: 10 };
        newsFetch(request, (news) => {
            this.setState({ data: news });
        });
    }


  render() {
    return (
      <div
        className={styles.carouselNewsContainer}
        style={{ display: "table" }}
      >
        <div style={{ display: "table-row" }}>
          <div
            className={styles.carouselContainer}
            style={{
              display: "table-cell",
              verticalAlign: "top",
              width: "auto"
            }}
          >
            <CCarousel
              menuExtended={this.props.menuExtended}
              currentSlideHandler={this.props.currentSlideHandler}
                        demoEnter={this.props.demoEnter}
                        showModal={this.props.showModal}
            />
          </div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "top",
              width: "16.8vw",
              /*border: "2px solid blue",*/
              height: "100%"
            }}
                >
                    {this.state.data.length > 0 && < NewsModule content={{ newsAPI: this.state.data }} />}
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
